import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FEATURES } from "../../../constants";
import Button from "../../shared/Button";
import "../../../styles/HomePage.css";
import Loading from "../../shared/Loading";

export const HomePage: React.FC = () => {
  const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
        const timer = setTimeout(() => setIsLoading(false), 700);
    return () => clearTimeout(timer);
  }, []);
 
  if (isLoading) {
    return <Loading message="Loading Shortfy Home Page..." />;
  }


  return (
    <div className="home-page">
      <div className="home-page__header">
        <h1 className="home-page__title">Welcome to Shortfy!</h1>
        <p className="home-page__subtitle">Choose your tool to get started.</p>
      </div>

      <div className="home-page__features-grid">
        {FEATURES.map((feature) => (
          <div key={feature.id} className="feature-showcase">
            <div className="feature-showcase__header">
              <div className="feature-showcase__header-text">
                <h1 className="feature-showcase__title">{feature.title}</h1>
                <p className="feature-showcase__tagline">{feature.tagline}</p>
              </div>
            </div>

            <p className="feature-showcase__description">
              {feature.description}
            </p>

            <Button
              variant="primary"
              onClick={() => navigate(feature.route)}
              className="feature-showcase__cta"
            >
              Get Started Now
            </Button>

            <div className="feature-showcase__features">
              <h3 className="feature-showcase__features-title">Key Features</h3>
              <ul className="feature-showcase__features-list">
                {feature.keyFeatures.map((item, index) => (
                  <li key={index} className="feature-showcase__features-item">
                    <span className="feature-showcase__features-icon">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePage;
